import GetAddressDetails from "api/addressFunction";
import React, { useState, useEffect, useRef } from "react";


const loadGoogleMapsScript = (callback) => {

  if (typeof window.google === "object" && typeof window.google.maps === "object") {
    callback();
    return;
  }

  const apiKey = process.env.REACT_APP_GOOGLE_MAPS_API_KEY;

  const script = document.createElement("script");
  script.src = `https://maps.googleapis.com/maps/api/js?key=${apiKey}&libraries=places`;
  script.async = true;
  script.defer = true;
  script.onload = callback;

  document.head.appendChild(script);
};

const LocationSearch = ({ setValues, setAddressData ,fetchApi,setSearchFirst,setMadeChanges }) => {

  const [query, setQuery] = useState("");
  const inputRef = useRef(null);
  const autocompleteRef = useRef(null);

  useEffect(() => {
    loadGoogleMapsScript(() => {
      if (window.google && inputRef.current) {
        // Initialize Autocomplete only once
        if (!autocompleteRef.current) {
          autocompleteRef.current = new window.google.maps.places.Autocomplete(
            inputRef.current,
            {
              types: ["geocode"], // Restrict results to address/location types
              fields: ["formatted_address", "geometry", "name"], // Fields to retrieve
            }
          );

          autocompleteRef.current.addListener("place_changed",async () => {
            const place = autocompleteRef.current.getPlace();

            if (place.geometry) {
              const latitude = place.geometry.location.lat();
              const longitude = place.geometry.location.lng();

              setQuery(place?.formatted_address);
             
              if(fetchApi){
                const address = await GetAddressDetails(latitude, longitude);
                setAddressData(address);
              };
              setMadeChanges(true)
              setValues((prev) => ({
                ...prev,
                latitude,
                longitude,
              }));

            }
          });
        }
      }
    });
  }, [setValues]);



  return (
    <input
      ref={inputRef}
      type="text"
      className="googleSearchInput"
      style={{
        width: "100%",
        padding: "0.7rem",
        fontSize: "1rem",
        border: "1px solid #ccc",
        borderRadius: "10px",
        marginBottom: "1rem",
        backdropFilter: "blur(10px)",
        backgroundColor: 'rgba(255, 255, 255, 0)',
        borderColor: 'rgba(0, 0, 0, 0)',
        color: '#ffffff',
      }}
      placeholder="Search for a location..."
      onChange={(e) => setQuery(e.target.value)}
      value={query}
    />
  );
};

export default LocationSearch;
